<template>
    <v-btn
        text
        :disabled="disabled"
        class="dash-link pa-0"
		height="140px"
		:width="width"
        :to="to"
        exact-active-class="dash-link-active"
		:tile="true"
        exact>
		<div>
			<div>
				<v-icon v-if="icon" size="60px">{{icon}}</v-icon>
			</div>
			<div>
				{{ title }}
			</div>
		</div>
    </v-btn>
</template>

<script>
export default {
	name: 'DashboardLink',
	props: {
		to: {
			type: Object,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			required: true,
		},
		active: {
			type: Boolean,
			default: true,
		},
		icon: {
			type: String,
			default: 'false',
		},
		width: {
			type: String,
			default: '100%',
		},
	},
	computed: {
		currentRouteName() {
			return this.$route.name === this.to.name;
		},
	},
};
</script>

<style lang="scss" scoped>

.dash-link {
	color:#000!important;
	background-color: #e4af0c!important;
	> div {
		height: 100%;
		width: 100%;
	}
	div {
		display:flex;
		flex-direction: column;
		justify-content: center;
		font-size: 10px;
		text-align: center;
		width:100%;
		> div:first-of-type {
			height: 80px;
		}
		>div:nth-child(2) {
			padding-top:10px;
			overflow: hidden;
			background-color: #e4af0c!important;
			max-width: 100%;
		}
	}
}
.nav-link:hover,
.nav-link-active {
    color: #e4af0c !important;
}
</style>
